import React from "react";
import { isJira } from "../../connections/atlassian/ap";

const TestRadioButtons = ({ selectInputType, inputType }) => {
  return (
    <div>
      <input
        name="no-input-data"
        type="radio"
        label="No input data"
        value="NO_DATA"
        onChange={selectInputType}
        checked={inputType === "NO_DATA"}
      />
      &nbsp; No Input Data &nbsp;&nbsp;
      <input
        name="custom-data"
        type="radio"
        label="Custom input data"
        value="CUSTOM_DATA"
        onChange={selectInputType}
        checked={inputType === "CUSTOM_DATA"}
      />
      &nbsp; Custom Input Data &nbsp;&nbsp;
      {isJira() && (
        <>
          <input
            name="issue-data"
            type="radio"
            label="Issue data"
            value="ISSUE_KEY"
            onChange={selectInputType}
            checked={inputType === "ISSUE_KEY"}
          />
          &nbsp; Issue Key &nbsp;&nbsp;
          <input name="jql-data" type="radio" label="JQL input data" value="JQL" onChange={selectInputType} checked={inputType === "JQL"} />
          &nbsp; JQL &nbsp;&nbsp;
        </>
      )}
    </div>
  );
};
export default TestRadioButtons;
